import RowMenu from "../../../core/components/data-grid/RowMenu";
import {Menu} from "antd";
import {t} from "i18next";
import {useHistory} from "react-router-dom";
import {Pages} from "../../../AppRouter";
import {useModal} from "../../../core/context/ModalContext";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import UserHospital from "../UserHospitalEdit";
import UserCreateEdit from "../UserCreateEdit";

export default function UserRowMenu({row})
{
    const history = useHistory();
    const {openModal, closeModal} = useModal()
    const {refreshDataGrid} = useDataGrid()

    return (
        <>
            <RowMenu text={row.id}>
                <Menu>
                    <Menu.Item
                        onClick={() => {
                            openModal(t('Edit User'), (
                                <UserCreateEdit
                                    userId={row.id}
                                    onSaved={() => { refreshDataGrid(); closeModal(); }}
                                />
                            ))
                        }}
                    >
                        {t('Edit')}
                    </Menu.Item>
                    <Menu.Item
                        onClick={() => {
                            openModal(t('User Hospitals'), (
                                <UserHospital userId={row.id}/>
                            ))
                        }}
                    >
                        {t('Edit Hospitals')}
                    </Menu.Item>
                </Menu>
            </RowMenu>
        </>
    )
}
